/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {OfferBindingValue} from "./offerBindingValue.zod";
import {OfferLiteralValue} from "./offerLiteralValue.zod";

export const OfferVariableValue = zod.union([OfferLiteralValue, OfferBindingValue]);

export type OfferVariableValue = zod.input<typeof OfferVariableValue>;
export type OfferVariableValueOutput = zod.output<typeof OfferVariableValue>;
